import { useState, useContext } from "react";
import { T } from "../../hooks/useTranslate";
import { Box } from "@mui/material";
import { styles } from "../../themes/datagrid.styles";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { PartnersSortButtonMenu } from "./PartnersSortButtonMenu";
import { PartnersContext } from "../../hooks/PartnersContext";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getFilterButtonStyling } from "./getFilterButtonStyling";

const PartnersSortButton = ({ logEvent}) => {
  const { loading, mobileColumn, sortModel } = useContext(PartnersContext);

  const theme = useTheme();
  const viewportIsSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleButtonClick = (event) => {
    const target = event.currentTarget;
    setAnchorEl(target);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        id="partners-sort-button"
        aria-controls={open ? "sort-partners-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-label="open partners sort menu"
        data-test-id={`partners-sort-button`}
        onClick={handleButtonClick}
        style={getFilterButtonStyling(loading, open, false)}
        sx={{
          ...styles.button,
          opacity: loading ? ".5" : null,
          paddingRight: "0.375rem",
          "&:hover": {
            cursor: loading ? "not-allowed" : "pointer",
            backgroundColor: "#FAFAFA"
          }
        }}>
        {viewportIsSmall ? <T>show</T> : <T>sort_by</T>}:&nbsp;
        <T>{viewportIsSmall ? formatSelection(mobileColumn) : formatSelection(sortModel[0].field)}</T>
        {open ? (
          <KeyboardArrowUpIcon sx={{ transform: "scale(.8)" }} />
        ) : (
          <KeyboardArrowDownIcon sx={{ transform: "scale(.8)" }} />
        )}
      </Box>
      <PartnersSortButtonMenu
        anchorEl={anchorEl}
        handleClose={handleClose}
        open={open}
        logEvent={logEvent}
      />
    </>
  );
};

export { PartnersSortButton };

function formatSelection(value) {
  switch (value) {
    case "name":
      return "name";
    case "nextRank":
      return "ov_to_next_rank";
    case "dateJoined":
      return "date_joined";
    case "centurionCount":
      return "centurion";
    case "newPartners":
      return "new_partners";
    case "totalOv":
      return "total_ov";
    case "uncompressedTv":
      return "tv";
    case "cpv":
      return "pv";
    case "asc":
      return "asc";
    case "desc":
      return "desc";
    case "relevance":
      return "relevance";
    default:
      return "undefined";
  }
}
